import { Outlet, Link } from "react-router-dom";
import Header from "./heading/Header";
import Footer from "./Footer/Footer";
import MobileApps from "./mobileApps/MobileApps";

const Layout = () => {
  return (
    <>
      <Header></Header>
      <Outlet />
      {/* <MobileApps></MobileApps> */}
      <Footer></Footer>
    </>
  );
};

export default Layout;
